// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mfa-container {
  min-height: calc(100vh - 62px);
  max-width: 690px; }
  .mfa-container .avatar {
    width: 100%;
    border-radius: 0;
    background: none;
    margin-bottom: 56px; }
    @media (min-width: 768px) {
      .mfa-container .avatar {
        margin-bottom: 95px; } }
  .mfa-container .login-form {
    width: 100%;
    max-width: 100%; }
    .mfa-container .login-form .login-field {
      margin: 0; }
      .mfa-container .login-form .login-field:nth-child(2) {
        margin: 15px 0; }
      .mfa-container .login-form .login-field label {
        font-size: 19px;
        line-height: 25px; }
      .mfa-container .login-form .login-field input {
        padding: 13px 0; }
    .mfa-container .login-form .checkpoint-info {
      font-size: 20px;
      color: #fff; }
    .mfa-container .login-form .submit-btn {
      font-size: 19px;
      width: 100%;
      margin-top: 40px; }
      @media (min-width: 768px) {
        .mfa-container .login-form .submit-btn {
          margin-top: 100px; } }
    .mfa-container .login-form .form-links {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between; }
      .mfa-container .login-form .form-links .MuiGrid-item {
        width: 100%; }
        @media (min-width: 480px) {
          .mfa-container .login-form .form-links .MuiGrid-item {
            width: 50%; }
            .mfa-container .login-form .form-links .MuiGrid-item.signup-link {
              text-align: right; } }
        .mfa-container .login-form .form-links .MuiGrid-item a:hover {
          color: var(--color-yellow) !important;
          text-decoration: none; }
    .mfa-container .login-form .info-text {
      color: #fff;
      font-size: 18px;
      margin: 10px 0px;
      display: flex;
      justify-content: center;
      gap: 3px; }
      .mfa-container .login-form .info-text .text-blue {
        font-weight: 400;
        font-size: 18px;
        line-height: 15.41px;
        color: #005296;
        text-decoration: underline;
        cursor: pointer;
        margin-top: 4px; }
      .mfa-container .login-form .info-text .text-yellow {
        font-weight: 400;
        font-size: 18px;
        line-height: 15.41px;
        color: var(--color-yellow);
        text-decoration: underline;
        cursor: pointer;
        margin-top: 4px; }
`, "",{"version":3,"sources":["webpack://./src/pages/mfa-checkpoint/MfaCheckpoint.scss"],"names":[],"mappings":"AAAA;EACI,8BAA8B;EAC9B,gBAAgB,EAAA;EAFpB;IAKQ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB,EAAA;IAEnB;MAVR;QAWY,mBAAmB,EAAA,EAE1B;EAbL;IAgBQ,WAAW;IACX,eAAe,EAAA;IAjBvB;MAoBY,SAAS,EAAA;MApBrB;QAuBgB,cAAc,EAAA;MAvB9B;QA2BgB,eAAe;QACf,iBAAiB,EAAA;MA5BjC;QAgCgB,eAAe,EAAA;IAhC/B;MAqCY,eAAe;MACf,WAAW,EAAA;IAtCvB;MA0CY,eAAe;MACf,WAAW;MACX,gBAAgB,EAAA;MAEhB;QA9CZ;UA+CgB,iBAAiB,EAAA,EAExB;IAjDT;MAoDY,aAAa;MACb,eAAe;MACf,8BAA8B,EAAA;MAtD1C;QAyDgB,WAAW,EAAA;QAEX;UA3DhB;YA4DoB,UAAU,EAAA;YA5D9B;cA+DwB,iBAAiB,EAAA,EACpB;QAhErB;UAqEwB,qCAAqC;UACrC,qBAAqB,EAAA;IAtE7C;MA6EY,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,aAAa;MACb,uBAAuB;MACvB,QAAQ,EAAA;MAlFpB;QAqFgB,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,cAAc;QACd,0BAA0B;QAC1B,eAAe;QACf,eAAe,EAAA;MA3F/B;QA+FgB,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,0BAA0B;QAC1B,0BAA0B;QAC1B,eAAe;QACf,eAAe,EAAA","sourcesContent":[".mfa-container {\n    min-height: calc(100vh - 62px);\n    max-width: 690px;\n\n    .avatar {\n        width: 100%;\n        border-radius: 0;\n        background: none;\n        margin-bottom: 56px;\n\n        @media (min-width: 768px) {\n            margin-bottom: 95px;\n        }\n    }\n\n    .login-form {\n        width: 100%;\n        max-width: 100%;\n\n        .login-field {\n            margin: 0;\n\n            &:nth-child(2) {\n                margin: 15px 0;\n            }\n\n            label {\n                font-size: 19px;\n                line-height: 25px;\n            }\n\n            input {\n                padding: 13px 0;\n            }\n        }\n\n        .checkpoint-info {\n            font-size: 20px;\n            color: #fff;\n        }\n\n        .submit-btn {\n            font-size: 19px;\n            width: 100%;\n            margin-top: 40px;\n\n            @media (min-width: 768px) {\n                margin-top: 100px;\n            }\n        }\n\n        .form-links {\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: space-between;\n\n            .MuiGrid-item {\n                width: 100%;\n\n                @media (min-width: 480px) {\n                    width: 50%;\n\n                    &.signup-link {\n                        text-align: right;\n                    }\n                }\n\n                a {\n                    &:hover {\n                        color: var(--color-yellow) !important;\n                        text-decoration: none;\n                    }\n                }\n            }\n        }\n\n        .info-text {\n            color: #fff;\n            font-size: 18px;\n            margin: 10px 0px;\n            display: flex;\n            justify-content: center;\n            gap: 3px;\n\n            .text-blue {\n                font-weight: 400;\n                font-size: 18px;\n                line-height: 15.41px;\n                color: #005296;\n                text-decoration: underline;\n                cursor: pointer;\n                margin-top: 4px;\n            }\n\n            .text-yellow {\n                font-weight: 400;\n                font-size: 18px;\n                line-height: 15.41px;\n                color: var(--color-yellow);\n                text-decoration: underline;\n                cursor: pointer;\n                margin-top: 4px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
